export default __webpack_public_path__ + "static/media/rap3.0ae83dde.jpg";